import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelper } from 'angular2-jwt';
import { LogService } from '../../shared/log/log.service';
import { IataByDefaultModalComponent } from '../../shared/iata-by-default-modal/iata-by-default-modal.component';
import {
  AuthenticationStore,
  ExternalSourceError
} from '../../permission/services/authentication.store';
import { UserPermission } from '../../permission/models/user-permission.model';
import { UserLocalStorageService } from '../../permission/services/user.local.storage.service';
import { Observable } from 'rxjs/Observable';
import { MultiAgency } from 'app/shared/models/multi-agency';
import { AppAuthHttpService } from 'app/http/app.auth.http.service';
import { EnvironmentConfiguration } from 'app/environment/services/environment.configuration';
import { ResponseUtilService } from 'app/shared/utils/response-util.service';

@Component({
  selector: 'pioneer-secured-home',
  templateUrl: './secured-home.component.html'
})
export class SecuredHomeComponent implements OnInit {

  @ViewChild(IataByDefaultModalComponent) iataByDefaultModal: IataByDefaultModalComponent;

  token: string;
  jwtHelper: JwtHelper;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private authenticationStore: AuthenticationStore,
              private userLocalStorageService: UserLocalStorageService,
              private logService: LogService,
              private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
    this.jwtHelper = new JwtHelper();
  }

  ngOnInit() {
    this.route.queryParams.map(params => params[ 'authorization' ]).filter(token => token)
      .delay(100) // We get errors without this delay
      .subscribe(token => this.storeTokenFromQueryString(token));
  }

  storeTokenFromQueryString(token: string): void {
    // this is necessary in case they were already logged in before coming to this page
    this.authenticationStore.logout(false);
    this.userLocalStorageService.removeItem(AuthenticationStore.MULTI_AGENCY_STR);

    this.authenticationStore.handleTokenFromExternalSource(token).subscribe(
      (userPermission: UserPermission) => {
        this.logService.debug('subscribe handleTokenFromExternalSource');
        if (this.authenticationStore.openDefaultArcIataModalPanel(userPermission.token)) {
          this.retrieveAgencies().subscribe(
            (data: MultiAgency[]) => {
              this.iataByDefaultModal.open(userPermission.token, data);
            },
            (error: ExternalSourceError) => {
              if (error === ExternalSourceError.TOKEN_EXPIRED) {
                this.router.navigate([ '/external-login-expired' ]);
                this.logService.debug(`after navigate['/external-login-expired']`);
              } else {
                this.router.navigate([ '/error', { error: 'MESSAGES.ERROR.EXTERNAL_LOGIN_ERROR' } ]);
              }
            }
          );
        } else {
          this.router.navigate([ '/' ], {replaceUrl: true});
        }
        this.logService.debug(`after navigate['/']`);
      },
      (error: ExternalSourceError) => {
        if (error === ExternalSourceError.TOKEN_EXPIRED) {
          this.router.navigate([ '/external-login-expired' ]);
          this.logService.debug(`after navigate['/external-login-expired']`);
        } else {
          this.router.navigate([ '/error', { error: 'MESSAGES.ERROR.EXTERNAL_LOGIN_ERROR' } ]);
        }
      }
    );
  }

  retrieveAgencies(): Observable<MultiAgency[]> {
    return this.http.get(this.environment.baseUrl + '/api/lookup/agencies/token')
    .map(response => response.json())
    .catch(response => this.responseUtilService.handleError(response)).share();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/auth/secured-home/secured-home.component.ts